import React, { useState, useEffect, useCallback } from "react";
import styles from "./Rally.module.css";
import ProgressBar from "../components/ProgressBar";
import NBLogo from "../components/NBLogo";
import NavPanel from "../components/NavPanel";
import TapArea from "../components/TapArea";

import { useNavigate } from "react-router-dom";

const products = [
  { name: "Product 1", img_main: 'delray/1_main.png', image: "delray/1_thumb.png", desc: 'White with Navy', link: '',
    dots: [ 
      {x: 50, y: 150, image: 'delray/1_3.png', feature: 'Durable', details: 'The rubber outsole is built to withstand even the longest matches, while the toe guard offers protection for toe draggers.'}, 
      {x: 120, y: 80, image: 'delray/1_1.png', feature: 'Inspired by Coco Gauff', details: 'The design is influenced by Coco’s personal style, and her favorite off-court New Balance models.'},
      {x: 285, y: 160, image: 'delray/1_2.png', feature: 'For all kinds of players', details: 'Offered in both men’s and women’s sizes, the Coco Delray is ready for any game, on any surface, from your local park to competitive play.'} ]},
  { name: "Product 2", img_main: 'delray/2_main.png', image: "delray/2_thumb.png", desc: 'White with Green Apple', link: 'https://www.newbalance.com/pd/coco-delray/WCHCODV2-48633.html?utm_source=fbig&utm_medium=so&utm_campaign=paid&utm_content=TennisMoMo&utm_term=CocoDelrayWCHCODG2&ecid=so_fbig_paid_TennisMoMo_CocoDelrayWCHCODG2',
    dots: [
    {x: 50, y: 150, image: 'delray/2_3.png', feature: 'Durable', details: 'The rubber outsole is built to withstand even the longest matches, while the toe guard offers protection for toe draggers.'}, 
    {x: 120, y: 80, image: 'delray/2_1.png', feature: 'Inspired by Coco Gauff', details: 'The design is influenced by Coco’s personal style, and her favorite off-court New Balance models.'},
    {x: 285, y: 160, image: 'delray/2_2.png', feature: 'For all kinds of players', details: 'Offered in both men’s and women’s sizes, the Coco Delray is ready for any game, on any surface, from your local park to competitive play.'} ]},
  { name: "Product 3", img_main: 'delray/3_main.png', image: "delray/3_thumb.png", desc: 'Parchment with NB Navy', link: 'https://www.newbalance.com/pd/coco-delray/WCHCODV2-48563.html?dwvar_WCHCODV2-48563_style=WCHCODI2&dwvar_WCHCODV2-48563_width=B&pid=WCHCODV2-48563&quantity=1#utm_source=fbig&utm_medium=so&utm_campaign=paid&utm_content=TennisMoMo&utm_term=CocoDelrayWCHCODI2&ecid=so_fbig_paid_TennisMoMo_CocoDelrayWCHCODI2',
    dots: [
    {x: 50, y: 150, image: 'delray/3_3.png', feature: 'Durable', details: 'The rubber outsole is built to withstand even the longest matches, while the toe guard offers protection for toe draggers.'}, 
    {x: 120, y: 80, image: 'delray/3_1.png', feature: 'Inspired by Coco Gauff', details: 'The design is influenced by Coco’s personal style, and her favorite off-court New Balance models.'},
    {x: 285, y: 160, image: 'delray/3_2.png', feature: 'For all kinds of players', details: 'Offered in both men’s and women’s sizes, the Coco Delray is ready for any game, on any surface, from your local park to competitive play.'} ]},
  { name: "Product 4", link: '', img_main: 'delray/4_main.png', image: "delray/4_thumb.png", desc: 'Bisque with Urgent Red', link: 'https://www.newbalance.com/pd/coco-delray/WCHCODV2-48657.html?dwvar_WCHCODV2-48657_style=WCHCODUS#utm_source=fbig&utm_medium=so&utm_campaign=paid&utm_content=&utm_term=CocoDelrayTennisMoMo&ecid=so_fbig_paid__CocoDelrayTennisMoMo',
    dots: [
      {x: 50, y: 150, image: 'delray/4_3.png', feature: 'Durable', details: 'The rubber outsole is built to withstand even the longest matches, while the toe guard offers protection for toe draggers.'}, 
      {x: 120, y: 80, image: 'delray/4_1.png', feature: 'Inspired by Coco Gauff', details: 'The design is influenced by Coco’s personal style, and her favorite off-court New Balance models.'},
      {x: 285, y: 160, image: 'delray/4_2.png', feature: 'For all kinds of players', details: 'Offered in both men’s and women’s sizes, the Coco Delray is ready for any game, on any surface, from your local park to competitive play.'} ]},
  // { name: "Product 5", img_main: 'delray/5_main.png', image: "delray/5_thumb.png", desc: 'Bisque with Urgent Red',  
  //   dots:[
  //     {x: 50, y: 150, image: 'delray/5_1.png', feature: 'Inspired by Coco Gauff', details: 'The design is influenced by Coco’s personal style, and her favorite off-court New Balance models.'}, 
  //     {x: 120, y: 90, image: 'delray/5_2.png', feature: 'For all kinds of players', details: 'Offered in both men’s and women’s sizes, the Coco Delray is ready for any game, on any surface, from your local park to competitive play.'},
  //     {x: 285, y: 160, image: 'delray/5_3.png', feature: 'Durable', details: 'The rubber outsole is built to withstand even the longest matches, while the toe guard offers protection for toe draggers.'} ]}    
];


const Delray = () => {
  const [active, setActive] = useState(0);
  const [featureNumber, setFeatureNumber] = useState();
  const activeProduct = products[active]
  const navigate = useNavigate();

  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate("/shop-cta");
  }, [navigate]);

  const onClickDot = (id) => {
    if (id == featureNumber) {
      setFeatureNumber(null)
    } else {
      setFeatureNumber(id)
    }    
  }
  
  const renderDots  = () => {
    return(
      (activeProduct.dots || []).map((dot, idx) => (
        ((featureNumber == null) || (featureNumber == idx)) && 
        <div 
          key={`${products[active].name}-dot-${idx}`} 
          style={{ left: `${dot.x}px`, top:  `${featureNumber == null ? dot.y : 190}px` }}
          className={`${styles.redCircle} ${featureNumber == null ? styles.redPulse : '' }`} 
          onClick={() => onClickDot(idx)}>
        </div>    
      ))
    )
  };
  
  const onClickLink =  (link) => {
    const url = products[active].link ? products[active].link : link

    umami?.track('Clicked shop on Delray page', { link: url });
    window.open(url)
  }

  return (
    <div className={styles.shopPage}>
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel postion='right' onClick={onNextPageClick} />

      <TapArea style={styles.topLeftNav} onClick={onPreviousPageClick} />
      <TapArea style={styles.bottomLeftNav} onClick={onPreviousPageClick} />

      <TapArea style={styles.topRightNav} onClick={onNextPageClick} />
      <TapArea style={styles.bottomRightNav} onClick={onNextPageClick} />

      <ProgressBar current='5' />
      <div className={styles.gradient}></div>

      <div className={styles.headerContainer}>
        <NBLogo />
        <div className={styles.productType}>
          Coco Delray 
        </div>

        <div className={styles.slogan}> 
          Created so anyone can pick up a racket and get in the game.
        </div> 
      </div>

      <div className={styles.productListContainer} >
        <div className={styles.detailArea}>
          <div className={styles.detailWrapper}>

            <img
              src={products[active].img_main}
              alt={products[active].name}
              className={styles.detailImg}
            />

            { featureNumber != null &&   
              <img
                src={activeProduct.dots[featureNumber].image}
                className={`${styles.detailImg} ${styles.featuredImage}`}
                onClick={() => onClickDot(featureNumber)}
              />
            }
            { featureNumber != null &&   
              <div className={`${styles.featureText}`} >
                <div className={styles.featureName}> {activeProduct.dots[featureNumber].feature} </div>
                <div className={styles.featureContent}> {activeProduct.dots[featureNumber].details} </div>
              </div> 
            }

            { renderDots() }
          </div>
        </div>
        <div className={styles.productList}>
          {products.map((product, idx) => (
            <div
              key={product.name}
              className={idx === active ? `${styles.productItem} ${styles.active}` : styles.productItem}
              onClick={() => { setActive(idx) ; setFeatureNumber(null) }}
            >
              <img
                src={product.image}
                alt={product.name}
                className={styles.productThumb}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.productDesc}> 
        {products[active].desc}
      </div>

      <a onClick={() => onClickLink('https://www.newbalance.com/pd/coco-delray/WCHCODV2-48563.html#dwvar_WCHCODV2-48563_style=WCHCODW2&dwvar_WCHCODV2-48563_width=B&pid=WCHCODV2-48563&quantity=1?utm_source=fbig&utm_medium=so&utm_campaign=paid&utm_content=TennisMoMo&utm_term=CocoDelrayWCHCODW2&ecid=so_fbig_paid_TennisMoMo_CocoDelrayWCHCODW2') }
        className={styles.btnShop}>        
        Shop
      </a>

      <div className={`${styles.text}`}>Every place has a story to tell.</div>
      { featureNumber != null &&   
        <div className={styles.overlay} onClick={() => setFeatureNumber(null)}></div>
      }
    </div>
  );
};

export default Delray;
